var React = require('react');

function Referrals (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"referrals_icon","d":"M15.492,2.448A1.391,1.391,0,0,0,14.175,1H9.366a1.246,1.246,0,0,0-.922.434L1.4,9.181a1.592,1.592,0,0,0,0,2.1L6.2,16.566a1.267,1.267,0,0,0,1.91,0l7.049-7.747a1.5,1.5,0,0,0,.4-1.014ZM11.54,6.864a1.391,1.391,0,0,1-1.317-1.448A1.391,1.391,0,0,1,11.54,3.968a1.391,1.391,0,0,1,1.317,1.448A1.391,1.391,0,0,1,11.54,6.864Z","transform":"translate(-1 -1)"}));
}

Referrals.defaultProps = {"width":"14.558","height":"16","viewBox":"0 0 14.558 16"};

module.exports = Referrals;

Referrals.default = Referrals;
